module.exports = __webpack_public_path__ + "media/application/images/icons/topics-living-wage-pebble-dark-green-rgb-1071506be00765d65742ea4f315cfe86.svg";